import React from "react";
import Layout from './Layout'
import { useMovieData } from '../hooks/useMovieData';
import { FullscreenProvider } from '../hooks/useFullscreen'


export default function App() {

  const {
    movieState,
    movieData,
    filters,
    getNextMovie,
    getSpecificMovie,
    updateCurrentMovieKinoRating,
    updateRange,
    allFiltersChecked,
    toggleCheckbox,
    toggleAllCheckboxes,
    resetFilters,
    searchQuery,
    searchIntent,
    searchLoading,
    showFilms,
    clearAll,
  } = useMovieData();

  return (
    <div>
        <FullscreenProvider>
          <Layout
            movie={{
              title: movieData.title,
              released: movieData.released,
              trailer: movieData.trailer,
              runtime: movieData.runtime,
              language: movieData.language,
              director: movieData.director,
              imdb_id: movieData.imdb_id,
              writer: movieData.writer,
              ratings: movieData.ratings,
              movieFound: movieState.movieFound,
              movieNotFound: movieState.movieNotFound,
            }}
            nav={{
              getNextMovie,
              getSpecificMovie,
              updateCurrentMovieKinoRating,
            }}
            filterControls={{
              filters,
              updateRange,
              allCheckboxesChecked: allFiltersChecked,
              toggleCheckbox,
              toggleAllCheckboxes,
              resetFilters,
            }}
            searchControls={{
              searchQuery,
              searchIntent,
              searchLoading,
              showFilms,
              clearAll,
            }}
          />
        </FullscreenProvider>
    </div>
  );
}